export function acceptHotReplacement(incomingModule: NodeModule) {
  if (incomingModule?.hot) {
    incomingModule.hot.accept();
  }
}
